const E = {
  DIV: "div",
  HEADER: "header",
  NAV: "nav",
  SECTION: "section",
  ARTICLE: "article",
  ASIDE: "aside",
  FOOTER: "footer",
  DETAILS: "details",
  SUMMARY: "summary",
  P: "p",
  SPAN: "span",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6"
};
export {
  E as VIEW_RENDER_AS
};
